var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 53,
    viewBox: "0 0 182 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.63147,
    width: 168.737,
    height: 1.96014,
    fill: "#181818"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.63147,
    y: 49.6567,
    width: 168.737,
    height: 2.61351,
    fill: "#181818"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.42102,
    y: 1.96021,
    width: 2.21053,
    height: 1.96014,
    fill: "#181818"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 175.369,
    y: 1.96021,
    width: 2.21053,
    height: 1.96014,
    fill: "#181818"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 177.579,
    y: 3.92017,
    width: 2.21053,
    height: 1.96014,
    fill: "#181818"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 175.369,
    y: 47.6965,
    width: 2.21053,
    height: 1.96014,
    fill: "#181818"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 177.579,
    y: 45.7366,
    width: 2.21053,
    height: 1.96014,
    fill: "#181818"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 4.42102,
    y: 47.6965,
    width: 2.21053,
    height: 1.96014,
    fill: "#181818"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 2.21045,
    y: 45.7366,
    width: 2.21053,
    height: 1.96014,
    fill: "#181818"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 2.21045,
    y: 3.92017,
    width: 2.21053,
    height: 1.96014,
    fill: "#181818"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    y: 5.88037,
    width: 2.21053,
    height: 39.8561,
    fill: "#181818"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 179.79,
    y: 5.88037,
    width: 2.21053,
    height: 39.8561,
    fill: "#181818"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 6.63147,
    y: 1.96021,
    width: 99.4737,
    height: 47.6966,
    fill: "#F6E0C6"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 4.42102,
    y: 3.92041,
    width: 2.21053,
    height: 43.7764,
    fill: "#F6E0C6"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 2.21045,
    y: 5.88062,
    width: 2.21053,
    height: 39.8561,
    fill: "#F6E0C6"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 75.8948,
    y: 1.96021,
    width: 99.4737,
    height: 47.6966,
    fill: "#F6E0C6"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 175.369,
    y: 3.92041,
    width: 2.21053,
    height: 43.7764,
    fill: "#F6E0C6"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 177.579,
    y: 5.88062,
    width: 2.21053,
    height: 39.8561,
    fill: "#F6E0C6"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 7.36841,
    y: 3.92017,
    width: 165.789,
    height: 1.30676,
    fill: "#835351"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 7.36841,
    y: 45.7361,
    width: 165.789,
    height: 1.30676,
    fill: "#835351"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 5.15796,
    y: 5.22681,
    width: 2.21053,
    height: 1.96014,
    fill: "#835351"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 5.15796,
    y: 43.7761,
    width: 2.21053,
    height: 1.96014,
    fill: "#835351"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 173.158,
    y: 5.22681,
    width: 2.21053,
    height: 1.96014,
    fill: "#835351"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 173.158,
    y: 43.7761,
    width: 2.21053,
    height: 1.96014,
    fill: "#835351"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 3.6842,
    y: 7.18701,
    width: 1.47368,
    height: 36.5892,
    fill: "#835351"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 175.369,
    y: 7.18701,
    width: 1.47368,
    height: 36.5892,
    fill: "#835351"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.1328 30.3125V31.75H70.2266V30.3125H75.7891V28.0156H71.7578V23.3906H79.8828V21.6406H71.7266V20.2344H81.6016V24.7656H73.4922V26.5938H81.9297V28.0156H77.5078V30.3125H83.1328ZM95.2891 20.6406V22.2344C95.2891 24.125 95.2891 26.0703 94.7734 29.0469L93.0078 28.8906C93.5547 26.1172 93.5547 24.0703 93.5547 22.2344V22.0469H85.4141V20.6406H95.2891ZM84.0547 31.4531V30.0312H96.9297V31.4531H84.0547ZM109.648 19.2812V29.4844H107.898V19.2812H109.648ZM98.1328 23.7344C98.1328 21.6797 99.7969 20.2109 101.945 20.2031C104.094 20.2109 105.75 21.6797 105.742 23.7344C105.75 25.8203 104.094 27.2812 101.945 27.2812C99.7969 27.2812 98.1328 25.8203 98.1328 23.7344ZM99.8359 23.7344C99.8281 24.9844 100.734 25.7656 101.945 25.7656C103.125 25.7656 104.039 24.9844 104.039 23.7344C104.039 22.5156 103.125 21.7188 101.945 21.7188C100.734 21.7188 99.8281 22.5156 99.8359 23.7344ZM100.305 33.1094V28.4531H102.055V31.7031H110.039V33.1094H100.305Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginButton);
export default __webpack_public_path__ + "static/media/LoginButton.7e052ce8fe28834cd1d17e296c0f4710.svg";
export { ForwardRef as ReactComponent };